<i class="icon-close close-icon clickable" (click)="cancel()"></i>

<h3 mat-dialog-title>{{ 'POLICYHOLDER_CONTACT_DATA' | translate }}</h3>
<p>{{'CONTACT_DATA_DIALOG.SUBHEADER' | translate }}</p>

<div mat-dialog-content>
    <div class="row form-row" *ngIf="contactData">
        <div class="col-7">
            <app-input-mask
                    [textMask]="{mask: '000 000 000', lazy: true}"
                    [(ngModel)]="contactData.phoneNumber"
                    [errorStateMatcher]="matchers.phoneNumber"
                    [label]="'LABEL.PHONE_NUMBER' | translate">
            </app-input-mask>
        </div>
    </div>

    <div class="row form-row" *ngIf="contactData">
        <div class="col-7">
            <app-input
                    [(ngModel)]="contactData.email"
                    [errorStateMatcher]="matchers.email"
                    [label]="'LABEL.EMAIL' | translate">
            </app-input>
        </div>
    </div>
</div>

<div mat-dialog-actions>
    <button type="button" class="btn btn-secondary" (click)="cancel()">
        {{ 'BUTTON.CANCEL' | translate }}
    </button>
    <button type="button" class="btn btn-primary" (click)="save()">
        {{ 'BUTTON.SAVE' | translate }}
    </button>
</div>

